import { fetch } from '../utils/fetch'
/*
    API:    GET
    NAME:   获取站点信息
*/
export function getSiteInfo() {
  return fetch({
    url: 'siteInfo',
    method: 'get'
  })
}

/*
    API:    GET
    NAME:   根据key获取TOKEN
*/
export function getKeyToken(data) {
  return fetch({
    url: 'quickLogin',
    method: 'get',
    params: data
  })
}

/*
    API:    POST
    NAME:   获取验证码
*/
export function getCode(data) {
  return fetch({
    url: 'getMsgVerifyCode',
    method: 'post',
    data: data
  })
}

/*
    API:    POST
    NAME:   登录获取Token
*/
export function login(data) {
  return fetch({
    url: 'login',
    method: 'post',
    data: data
  })
}

/*
    API:    GET
    NAME:   Token获取信息
*/
export function getUserInfo() {
  return fetch({
    url: 'current',
    method: 'get'
  })
}

/*
    API:    POST
    NAME:   WX扫码信息
*/
export function getWxcode() {
  return fetch({
    url: 'WX/getWXCodeParam',
    method: 'post'
  })
}

/*
    API:    POST
    NAME:   WX登录验证
*/
export function isLogin(state) {
  return fetch({
    url: `/WX/selectLoginResult/${state}`,
    method: 'post'
  })
}

/*
    API:    GET
    NAME:   发送退出登录
*/
export function sendLogout() {
  return fetch({
    url: 'logout',
    method: 'get'
  })
}

/*
    API:    POST
    NAME:   切换账本
*/
export function switchSubarea(data) {
  return fetch({
    url: 'subarea/switchSubarea',
    method: 'post',
    data: data
  })
}

